(() => {
  if (customElements.get('sf-beam-toggle')) return;

class SkyfireBeamToggle extends HTMLElement {
  connectedCallback() {
    if (this.dataset.initialized === 'true') return;

    this.dataset.initialized = 'true';
    this.tabs = Array.from(this.querySelectorAll('[data-sf-beam-tab]'));
    this.panels = Array.from(this.querySelectorAll('[data-sf-beam-panel]'));

    if (!this.tabs.length || !this.panels.length) return;

    this.handleClick = this.handleClick.bind(this);
    this.handleKeydown = this.handleKeydown.bind(this);
    this.handleBlockSelect = this.handleBlockSelect.bind(this);

    this.addEventListener('click', this.handleClick);
    this.addEventListener('keydown', this.handleKeydown);

    if (window.Shopify && window.Shopify.designMode) {
      document.addEventListener('shopify:block:select', this.handleBlockSelect);
    }
  }

  disconnectedCallback() {
    if (this.handleClick) this.removeEventListener('click', this.handleClick);
    if (this.handleKeydown) this.removeEventListener('keydown', this.handleKeydown);
    if (this.handleBlockSelect) document.removeEventListener('shopify:block:select', this.handleBlockSelect);
  }

  handleClick(event) {
    const tab = event.target.closest('[data-sf-beam-tab]');
    if (!tab || !this.contains(tab)) return;

    this.activate(tab.dataset.blockId);
  }

  handleKeydown(event) {
    const currentTab = event.target.closest('[data-sf-beam-tab]');
    if (!currentTab || !this.contains(currentTab)) return;

    const currentIndex = this.tabs.indexOf(currentTab);
    let nextIndex = currentIndex;

    if (event.key === 'ArrowRight') nextIndex = (currentIndex + 1) % this.tabs.length;
    if (event.key === 'ArrowLeft') nextIndex = (currentIndex - 1 + this.tabs.length) % this.tabs.length;
    if (event.key === 'Home') nextIndex = 0;
    if (event.key === 'End') nextIndex = this.tabs.length - 1;

    if (nextIndex === currentIndex && !['Home', 'End'].includes(event.key)) return;
    if (!['ArrowRight', 'ArrowLeft', 'Home', 'End'].includes(event.key)) return;

    event.preventDefault();
    const nextTab = this.tabs[nextIndex];
    this.activate(nextTab.dataset.blockId, true);
  }

  handleBlockSelect(event) {
    const blockId = event.detail && event.detail.blockId;
    if (!blockId || !this.tabs.some((tab) => tab.dataset.blockId === blockId)) return;

    this.activate(blockId);
  }

  activate(blockId, moveFocus = false) {
    const activeTab = this.tabs.find((tab) => tab.dataset.blockId === blockId);
    const activePanel = this.panels.find((panel) => panel.dataset.blockId === blockId);

    if (!activeTab || !activePanel) return;

    this.tabs.forEach((tab) => {
      const isActive = tab === activeTab;
      tab.classList.toggle('is-active', isActive);
      tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
      tab.tabIndex = isActive ? 0 : -1;
    });

    this.panels.forEach((panel) => {
      const isActive = panel === activePanel;
      panel.hidden = !isActive;
      panel.classList.toggle('is-active', isActive);
    });

    const deferredTemplate = activePanel.querySelector('template[data-sf-beam-template]');
    if (deferredTemplate) {
      deferredTemplate.replaceWith(deferredTemplate.content.cloneNode(true));
    }

    activePanel.classList.remove('is-switching');
    void activePanel.offsetWidth;
    activePanel.classList.add('is-switching');
    window.setTimeout(() => activePanel.classList.remove('is-switching'), 200);

    if (moveFocus) activeTab.focus();
  }
}

customElements.define('sf-beam-toggle', SkyfireBeamToggle);
})();
